// Centralized image manifest — easy to swap later.
export const IMG = {
  // Pool & exterior
  poolMountain: "https://customer-assets.emergentagent.com/job_istron-luxury/artifacts/eh5by2y4_507608104.jpg",
  poolAerial: "https://customer-assets.emergentagent.com/job_istron-luxury/artifacts/dvea5qxr_507606217.jpg",
  poolSunloungers: "https://customer-assets.emergentagent.com/job_istron-luxury/artifacts/h255ns61_507624230.jpg",
  poolPalm: "https://customer-assets.emergentagent.com/job_istron-luxury/artifacts/cqhzn65n_507630210.jpg",
  aerialProperty: "https://customer-assets.emergentagent.com/job_istron-luxury/artifacts/hc8txsfb_549082806.jpg",

  // Garden / branding
  villaSign: "https://customer-assets.emergentagent.com/job_istron-luxury/artifacts/i1apgj66_507604490.jpg",

  // Balcony / terrace
  balconyMountain: "https://customer-assets.emergentagent.com/job_istron-luxury/artifacts/5rsudot2_507600833.jpg",
  terraceStone: "https://customer-assets.emergentagent.com/job_istron-luxury/artifacts/p26r1yqf_507600250.jpg",

  // Apartments interior
  bedroomGarden: "https://customer-assets.emergentagent.com/job_istron-luxury/artifacts/qnxyh9sg_507583465.jpg",
  livingRoom: "https://customer-assets.emergentagent.com/job_istron-luxury/artifacts/cps0y2je_507600721.jpg",
  livingArches: "https://customer-assets.emergentagent.com/job_istron-luxury/artifacts/9c7uxqw8_507597438.jpg",
  livingEntry: "https://customer-assets.emergentagent.com/job_istron-luxury/artifacts/8ney3cvr_507599377.jpg",
  twinRoomDoor: "https://customer-assets.emergentagent.com/job_istron-luxury/artifacts/yfhtnpui_507639774.jpg",
  twinRoomBlue: "https://customer-assets.emergentagent.com/job_istron-luxury/artifacts/q0x3mflm_507641874.jpg",

  // Additional photos from Booking.com (upgraded to max1024x768)
  bathroom: "https://cf.bstatic.com/xdata/images/hotel/max1024x768/873620719.jpg?k=7d7c78c7fc68177d6d2b070c1b891d0d7380bf8b09da632362a97e9fbe22c229&o=",
  cribRoom: "https://cf.bstatic.com/xdata/images/hotel/max1024x768/873626213.jpg?k=0d97474773223bf9559bec3d1a4db22b8e1bda593b42d8d4de1876503f99956c&o=",
  masterBed: "https://cf.bstatic.com/xdata/images/hotel/max1024x768/871470898.jpg?k=150f8c34c36bb53e1a5e6d700537b3884d159d5224cd805d04c447c4cf40fabd&o=",
};
